import { getIconById } from '@/services/aiApps';
import { constructImage } from './image';

const getIconByAppID = async (app) => {
  const iconRes = await getIconById(app.icon_id);
  if (!iconRes) return app;
  const contentType = iconRes.headers?.['content-type'];
  const iconUrl = constructImage(contentType, iconRes);
  return { ...app, icon: iconUrl };
};

export default getIconByAppID;
